module.exports = __webpack_public_path__ + "static/media/calibri-regular.baf2d27a.ttf";